import { render } from "./MerchantStoreAccounts.vue?vue&type=template&id=0c831ff4&ts=true"
import script from "./MerchantStoreAccounts.vue?vue&type=script&lang=ts"
export * from "./MerchantStoreAccounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__